import { tenantStore } from '../state/tenant-store';

export const useTenant = () => tenantStore();


